import axios from 'axios'
import { z } from 'zod'
import {
  CreateProviderCategory,
  ProviderCategorySchema,
  UpdateProviderCategory,
} from '@/queries/providers/categories/schema.ts'

export async function GETProviderCategories() {
  const response = await axios.get('/provider_categories')
  return z.array(ProviderCategorySchema).parse(response.data)
}

export async function POSTProviderCategory(data: CreateProviderCategory) {
  const response = await axios.post('/provider_categories', data)
  return response.data
}

export async function PUTProviderCategory(
  id: number,
  data: UpdateProviderCategory
) {
  const response = await axios.put(`/provider_categories/${id}`, data)
  return response.data
}
